import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=c5e68a86&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5e68a86')) {
      api.createRecord('c5e68a86', component.options)
    } else {
      api.reload('c5e68a86', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=c5e68a86&", function () {
      api.rerender('c5e68a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C07swQ0fYdp1/JS/comp/starrating.vue"
export default component.exports